import { Component } from '@angular/core';

@Component({
  selector: 'eid-registration-pending',
  templateUrl: './registration-pending.component.html',
  styleUrls: ['./registration-pending.component.scss']
})
export class RegistrationPendingComponent {}
